import React, {useState, useEffect} from "react";
import {
  DatePicker as MobileDatePicker,
  Form as MobileForm,
  Radio as MobileRadio
} from 'antd-mobile';
import cx from 'classnames';
import {DatePicker, Form, Select, Space} from "antd";
import moment, {Moment} from "moment";
import {CloseCircleFill} from "antd-mobile-icons";
import {useRequest} from "ahooks";
import {FormInstance} from "antd/lib/form/hooks/useForm";
import {ExamMethod} from "@/types";
import MobileComponentWrapper from "@/components/MobileComponentWrapper";
import PcComponentWrapper from "@/components/PcComponentWrapper";
import {apiGetSchBatch} from "@/services/exam_signup";
import {range} from "@/utils/index";
import styles from './styles.module.less';

type TChooseExamTime = {
  method: number;
  certId: string;
  form?: FormInstance<any>;
  onSchTimeChange:(time: number) => void;
}
const ChooseExamTime: React.FC<TChooseExamTime> = ({onSchTimeChange,form, certId, method}) => {
  const [examStartTime, setExamStartTime] = useState<Moment | null>(null); // 考试开始时间
  const [mobileTimePickerVisible, setMobileTimePickerVisible] = useState(false);
  const [batchList, setBatchList] = useState<{
    label: string;
    value: string;
  }[]>([])

  function disabledDateFun(current: Moment) {
    return current && (current < moment().subtract(1, 'd').endOf('day')) || (current > moment().add(1, 'y').endOf('day'));
  }

  const {run: getBatch} = useRequest(() => {
    return apiGetSchBatch(certId)
  }, {
    manual: true,
    onSuccess: (res) => {
      console.log('批次数据是');
      console.log(res);
      if (res.code === 200) {
        setBatchList(res.data.map(item => ({
          label: `第${item.name}期 （${moment(item.startTime).format('YYYY-MM-DD HH:mm:ss')}-${moment(item.endTime).format('YYYY-MM-DD HH:mm:ss')})`,
          value: item.schId,
          startTime: item.startTime,
        })));
      }
    }
  })

  useEffect(() => {
    if (method === 1) {
      getBatch();
    }
  }, [method]);

  return (
    <>
      <MobileComponentWrapper>
        {method === ExamMethod.batchTime ? (
          <MobileForm.Item name='schId' label={<div className={styles.tips_text}>考试批次</div>} required>
            <MobileRadio.Group>
              <Space direction='vertical'>
                {batchList.map((batch) => {
                  return (
                    <MobileRadio key={batch.value} value={batch.value}>{batch.label}</MobileRadio>
                  )
                })}
              </Space>
            </MobileRadio.Group>
          </MobileForm.Item>
        ) : (
          <>
            <MobileForm.Item
              noStyle
              shouldUpdate={(prevValues, curValues) =>
                prevValues.birthday !== curValues.birthday
              }
            >
              {({getFieldValue, setFieldsValue}) => (
                <MobileForm.Item
                  name='examStartTime'
                  rules={[{required: true, message: '考试时间不能为空'}]}
                  label={<div className={styles.tips_text}>考试时间</div>}
                  trigger='onConfirm'
                  arrow={
                    getFieldValue('birthday') ? (
                      <CloseCircleFill
                        style={{
                          color: 'var(--adm-color-light)',
                          fontSize: 14,
                        }}
                        onClick={e => {
                          e.stopPropagation()
                          setFieldsValue({birthday: ''})
                        }}
                      />
                    ) : null
                  }
                  onClick={() => {
                    setMobileTimePickerVisible(true)
                  }}
                >
                  <MobileDatePicker
                    precision='minute'
                    visible={mobileTimePickerVisible}
                    onClose={() => {
                      setMobileTimePickerVisible(false)
                    }}
                  >
                    {value =>
                      value ? moment(value).format('YYYY-MM-DD') : '请选择日期'
                    }
                  </MobileDatePicker>
                </MobileForm.Item>
              )}
            </MobileForm.Item>
          </>
        )}
      </MobileComponentWrapper>
      <PcComponentWrapper>
        <Form.Item
          className={cx(styles.row, styles.row_gap)}
          labelAlign="right"
          name={method === ExamMethod.batchTime ? 'schId' : 'examStartTime'}
          label={<span className={styles.tips_text}>{method === ExamMethod.batchTime ? '报考批次：' : '开考时间：'}</span>}
          rules={[
            {
              validator: async(_, fieldValue)=>{
                if (method === ExamMethod.batchTime) {
                  if (!fieldValue) {
                    return Promise.reject(new Error('请选择考试批次'));
                  }
                  return Promise.resolve();
                }
                if (moment(fieldValue).isBefore(moment())) {
                  console.log('触发');
                  return Promise.reject(new Error('不能选择当前时刻之前的时间'));
                }
                return Promise.resolve();

              },
            },
            {required: true, message: method === ExamMethod.batchTime ? '请选择考试批次' : "请选择时间"}
          ]}
        >
          {method === ExamMethod.batchTime ? (
            <Select style={{width:450}} placeholder="请选择考试批次" options={batchList} onChange={(value, option:any) => {
              onSchTimeChange?.(option.startTime)
            }}/>
          ) : (
            <DatePicker
              inputReadOnly
              value={examStartTime}
              showToday={false}
              showNow={false}
              showTime={{format: 'HH:mm', minuteStep: 10, showSecond: false}}
              disabledDate={disabledDateFun}
              // disabledMinutes={(selectedHour: number) => {
              //   return range(0,60).slice(0,moment().minute());
              // }}
              // disabledHours={() => range(0,24).slice(0,moment().hour())}
              onChange={(value, dateString) => {
                console.log('onChange了');
                console.log(value);
                if (value) {
                  const min = value.minutes();
                  let newMin;
                  if (min < 10) {
                    newMin = 0;
                  } else if (min >= 10 && min < 50) {
                    newMin = Number(`${parseInt(String(min / 10), 10)}0`);
                  } else {
                    newMin = 50;
                  }
                  const newValue = value.minutes(newMin).seconds(0);
                  setExamStartTime(moment(newValue, 'YYYY-MM-DD HH:mm'));
                  if (form) {
                    form.setFieldsValue({examStartTime: moment(newValue, 'YYYY-MM-DD HH:mm')})
                  }
                } else {
                  setExamStartTime(null);
                }
              }}
            />
          )}
        </Form.Item>
      </PcComponentWrapper>
    </>
  )
}
export default ChooseExamTime
